import React, { type ReactNode } from 'react';

export type StateProps = {
	isAutoSchedulerEnabled: boolean;
};

export type Props = StateProps & {
	children: (enabled: boolean) => ReactNode;
};

const AutoSchedulerSwitch = (props: Props) => {
	const { children, isAutoSchedulerEnabled } = props;

	return <>{children(isAutoSchedulerEnabled)}</>;
};

export default AutoSchedulerSwitch;
